/* Pelux · Cadeau offert pendant une édition limitée (réglages « Pelux · Cadeau offert »).
 *
 * Tient le panier dans un seul état, quel que soit le chemin qui l'a modifié :
 *   - un produit déclencheur au panier (réglage cadeau_declencheurs : la laisse d'exploration,
 *     seule ou dans le duo avec le kit — décision d'Ilyes du 2026-10-14) et l'édition ouverte →
 *     UNE ligne cadeau ;
 *   - sinon → aucune ligne cadeau (déclencheur retiré, kit seul, cadeau ajouté seul par son URL,
 *     édition finie).
 * Le cadeau est un produit à 0 € : aucune remise en jeu, donc aucun conflit avec le duo laisse,
 * dont la remise ne se cumule avec aucune autre remise produit.
 *
 * Où il se branche :
 *   - CartDrawer.renderContents, par où passent TOUS les ajouts (formulaire de la fiche, barre
 *     collante, CTA final, duo, cross-sell) : le tiroir s'ouvre aussitôt sur l'ajout, puis se
 *     re-rend avec le cadeau une requête plus tard ;
 *   - l'événement cartUpdate des lignes du panier (quantité, « Retirer ») : si le dernier
 *     déclencheur part, le cadeau part aussi, et les lignes se re-rendent d'elles-mêmes
 *     (CartItems.onCartUpdate) ;
 *   - le chargement de chaque page : un panier d'avant l'édition, ou d'après, est remis d'aplomb.
 *
 * La règle d'ouverture est posée par layout/theme.liquid (window.peluxCadeau) : thème publié,
 * entre les deux dates ; aperçu, toujours. Elle est relue ici à chaque fois, pour qu'une page
 * restée ouverte n'ajoute plus rien après la date de fin.
 * Chargé depuis layout/theme.liquid, après cart-drawer.js — jamais depuis un snippet : un script
 * réinjecté par la Section Rendering API ne s'exécute pas.
 */
(function () {
  var cfg = window.peluxCadeau;
  if (!cfg || !cfg.produit || !cfg.variante || !cfg.declencheurs) return;
  var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function ouvert() {
    if (!cfg.ouvert) return false;
    return cfg.apercu || Date.now() <= cfg.fin;
  }

  function envoyer(chemin, corps) {
    return fetch(racine + chemin, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps),
    }).then(function (r) {
      return r.json();
    });
  }

  /* Remet le panier dans l'état voulu. Rend la réponse de Shopify (avec `sections` si on en a
     demandé) quand il a fallu changer quelque chose, null sinon. Les appels passent l'un après
     l'autre : deux ajouts rapprochés ne mettent jamais deux cadeaux. */
  var file = Promise.resolve();
  function reconcilier(sections) {
    var tache = file.then(function () {
      return fetch(racine + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (panier) {
          var items = (panier && panier.items) || [];
          var declencheur = items.some(function (i) {
            return cfg.declencheurs.indexOf(i.product_id) !== -1;
          });
          var lignes = items.filter(function (i) {
            return i.product_id === cfg.produit;
          });
          var present = lignes.reduce(function (n, i) {
            return n + i.quantity;
          }, 0);
          var voulu = ouvert() && declencheur ? 1 : 0;
          if (present === voulu) return null;

          var rendu = sections && sections.length ? { sections: sections, sections_url: window.location.pathname } : {};
          if (voulu === 1 && present === 0) {
            return envoyer('cart/add.js', Object.assign({ items: [{ id: cfg.variante, quantity: 1 }] }, rendu));
          }
          var maj = {};
          lignes.forEach(function (l, k) {
            maj[l.key] = voulu === 1 && k === 0 ? 1 : 0;
          });
          return envoyer('cart/update.js', Object.assign({ updates: maj }, rendu));
        });
    });
    file = tache.catch(function () {});
    return tache;
  }

  /* Compteur de l'en-tête : section « cart-icon-bubble », même remplacement que assets/cart.js. */
  function majBulle(sections) {
    if (!sections || sections['cart-icon-bubble'] == null) return;
    var bulle = document.getElementById('cart-icon-bubble');
    if (!bulle) return;
    var source = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
    if (source) bulle.innerHTML = source.innerHTML;
  }

  /* Les lignes du panier (tiroir, page /cart) se re-rendent seules sur un cartUpdate qui ne vient
     pas d'elles : voir CartItems.onCartUpdate dans assets/cart.js. */
  function prevenirLesLignes(etat) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pelux-cadeau', cartData: etat });
  }

  function corrigerEtPrevenir() {
    return reconcilier(['cart-icon-bubble']).then(function (res) {
      if (!res || res.status) return;
      majBulle(res.sections);
      prevenirLesLignes(res);
    });
  }

  /* Re-rend le tiroir sans le rouvrir : même boucle que CartDrawer.renderContents. */
  function rendreTiroir(tiroir, sections) {
    tiroir.getSectionsToRender().forEach(function (s) {
      var cible = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      if (cible && sections[s.id] != null) cible.innerHTML = tiroir.getSectionInnerHTML(sections[s.id], s.selector);
    });
    var voile = tiroir.querySelector('#CartDrawer-Overlay');
    if (voile) voile.addEventListener('click', tiroir.close.bind(tiroir));
    // Le contenu réécrit a emporté le piège à focus que open() avait posé : on le repose.
    if (tiroir.classList.contains('active') && typeof trapFocus === 'function') {
      var conteneur = document.getElementById('CartDrawer');
      var focus = tiroir.querySelector('.drawer__inner') || tiroir.querySelector('.drawer__close');
      if (conteneur && focus) trapFocus(conteneur, focus);
    }
  }

  // 1. Tous les ajouts au panier finissent par CartDrawer.renderContents.
  if (window.customElements) {
    customElements.whenDefined('cart-drawer').then(function () {
      var Tiroir = customElements.get('cart-drawer');
      if (!Tiroir || Tiroir.prototype.peluxCadeau) return;
      var origine = Tiroir.prototype.renderContents;
      Tiroir.prototype.renderContents = function (etat) {
        origine.call(this, etat);
        var tiroir = this;
        var ids = tiroir.getSectionsToRender().map(function (s) {
          return s.id;
        });
        reconcilier(ids)
          .then(function (res) {
            if (res && !res.status && res.sections) rendreTiroir(tiroir, res.sections);
          })
          .catch(function () {});
      };
      Tiroir.prototype.peluxCadeau = true;
    });
  }

  // 2. Quantité changée ou ligne retirée, dans le tiroir ou sur /cart.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
      if (!evt || evt.source !== 'cart-items') return;
      corrigerEtPrevenir().catch(function () {});
    });
  }

  // 3. Au chargement : seulement si le panier rendu par le serveur ne suit pas la règle.
  var attendu = ouvert() && cfg.declencheur ? 1 : 0;
  if (cfg.cadeau !== attendu) corrigerEtPrevenir().catch(function () {});
})();
